import { MenuOutlined } from '@ant-design/icons'
import { useContext } from 'react'

import { DragContext } from './DragContext'

export const DragHandle = () => {
  const { setActivatorNodeRef, listeners } = useContext(DragContext)

  return (
    <MenuOutlined
      style={{ cursor: 'grab', color: '#999' }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  )
}
